import createReactComponent from '../createReactComponent';
export default createReactComponent('wash-dry-f', 'IconWashDryF', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 16v-8h4', key: 'svg-1' }],
  ['path', { d: 'M13 12h-3', key: 'svg-2' }],
]);
